import { render, staticRenderFns } from "./IrcInput.vue?vue&type=template&id=6c7545d9&"
import script from "./IrcInput.vue?vue&type=script&lang=js&"
export * from "./IrcInput.vue?vue&type=script&lang=js&"
import style0 from "./IrcInput.vue?vue&type=style&index=0&id=6c7545d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports